export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Update.vue?vue&type=template&id=475e1b7c"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Crews/Update.vue?vue&type=template&id=475e1b7c
// module id = 2530
// module chunks = 31